import { provideState } from '@ngrx/store';
import { TICKET_FEATURE_KEY, TicketEffects, TicketFacade, ticketReducer } from './+state';
import { provideEffects } from '@ngrx/effects';

export * from './+state';


export const ticketProviders = [

  // ngrx
  TicketFacade,
  provideState(TICKET_FEATURE_KEY, ticketReducer),
  provideEffects(TicketEffects),
];
